
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/listings",
      function () {
        return require("private-next-pages/listings.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/listings"])
      });
    }
  